/*
 *  PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2025 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
/* eslint-disable max-len */

/**
 * ExpandedBack icon
 *
 * @file ExpandedBack.jsx
 * @author Ujjwal Sana
 * @since 0.0.1
 */

import React from 'react';

const ExpandedBack = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
    <rect
      x="0"
      y="0"
      width="6"
      height="12"
      rx="4"
      fill="transparent"
      stroke="transparent"
      strokeWidth="1"
      className="left-hover-fill"
    />
    <path d="M2.00269 0C1.44917 0 0.977045 0.19544 0.586325 0.586319C0.195604 0.977199 0.000244141 1.44625 0.000244141 1.99349V10.0065C0.000244141 10.5603 0.195604 11.0293 0.586325 11.4137C0.977045 11.8046 1.44917 12 2.00269 12H13.9978C14.5513 12 15.0234 11.8046 15.4142 11.4137C15.8049 11.0228 16.0002 10.5537 16.0002 10.0065V1.99349C16.0002 1.43974 15.8049 0.970684 15.4142 0.586319C15.0234 0.19544 14.5513 0 13.9978 0H2.00269ZM0.996581 1.99349C0.996581 1.71987 1.09426 1.48534 1.28962 1.2899C1.48498 1.09446 1.72267 0.996743 2.00269 0.996743H5.00147V11.0033H2.00269C1.72918 11.0033 1.49149 10.9055 1.28962 10.7101C1.09426 10.5147 0.996581 10.2801 0.996581 10.0065V1.99349ZM5.9978 11.0033V0.996743H13.9978C14.2713 0.996743 14.509 1.09446 14.7109 1.2899C14.9062 1.48534 15.0039 1.71987 15.0039 1.99349V10.0065C15.0039 10.2801 14.9062 10.5147 14.7109 10.7101C14.5155 10.9055 14.2778 11.0033 13.9978 11.0033H5.9978Z" fill="currentColor" />
    <path d="M10.1773 7.37785L11.1736 6.49837H7.49109C7.35433 6.49837 7.23712 6.44951 7.13944 6.35179C7.04176 6.25407 6.99292 6.13681 6.99292 6C6.99292 5.86319 7.04176 5.74593 7.13944 5.64821C7.23712 5.55049 7.35433 5.50163 7.49109 5.50163H11.1736L10.1773 4.62215C10.0666 4.53094 10.008 4.41694 10.0015 4.28013C9.99495 4.14332 10.0373 4.0228 10.1284 3.91857C10.2196 3.81433 10.3336 3.75896 10.4703 3.75244C10.6071 3.73941 10.7276 3.7785 10.8317 3.86971L12.8342 5.61889C12.9449 5.72313 13.0002 5.85016 13.0002 6C13.0002 6.15635 12.9449 6.28339 12.8342 6.38111L10.8317 8.13029C10.7276 8.21498 10.6071 8.25407 10.4703 8.24756C10.3336 8.24104 10.2196 8.18567 10.1284 8.08143C10.0373 7.9772 9.99495 7.85668 10.0015 7.71987C10.0145 7.58306 10.0731 7.46906 10.1773 7.37785Z" fill="#020917" />
  </svg>
);

export default ExpandedBack;
